import { render, staticRenderFns } from "./icon-no-module-access.vue?vue&type=template&id=254da1ad&"
import script from "./icon-no-module-access.vue?vue&type=script&lang=js&"
export * from "./icon-no-module-access.vue?vue&type=script&lang=js&"
import style0 from "./icon-no-module-access.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDivider,VImg,VMenu,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('254da1ad')) {
      api.createRecord('254da1ad', component.options)
    } else {
      api.reload('254da1ad', component.options)
    }
    module.hot.accept("./icon-no-module-access.vue?vue&type=template&id=254da1ad&", function () {
      api.rerender('254da1ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/icon-no-module-access/icon-no-module-access.vue"
export default component.exports